module.exports = __webpack_public_path__ + "img/popup-bg-invited.c8787d0.png";